// extracted by mini-css-extract-plugin
export default {"wrapper":"MoqInputField_wrapper__JuwpF","inputCurrency":"MoqInputField_inputCurrency__Hu4Hj","priceText":"MoqInputField_priceText__0gWPK"};